import { Link, Launch } from '@mui/icons-material'
import Tag from '../Tag'
import styles from './WebsiteTag.module.scss'

const WebsiteTag = ({website, companyName}) => {
    return (
        <Tag 
            label={(<a className={styles['website-content']} href={website || `https://www.google.com/search?q=${companyName}`} 
            target='_blank' 
            rel="noreferrer">
                <Link/> <b>Website</b> <Launch color='textSecondary' style={{padding: '4px'}}/>
            </a>)}/>
    )
}

export default WebsiteTag